import gql from 'graphql-tag';
import PaginatorInfoFragment from '../fragments/PaginatorInfoFragment';
import AdminProductAllData from '../fragments/AdminProductAllData';

export default gql`
query adminProduct($filters: AdminProductFilters, $sortBy: AdminProductOrder, $count: Int!, $page: Int) {
    adminProducts(filters: $filters, sortBy: $sortBy, first: $count, page: $page) {
        paginatorInfo {
            ...PaginatorInfoFragment
        }
        data {
            ...AdminProductAllData
        }
    }
}
${PaginatorInfoFragment}
${AdminProductAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/queries/adminProduct.ts